import React from "react";
import { Link } from "react-router-dom";

const TermsAndConditionLabel = () => {
  return (
    <span>
      {" "}
      I agree to{" "}
      <Link to="/termsOfUse" className="font-semibold" target="_blank">
        the terms of use
      </Link>{" "}
      and{" "}
      <Link to="/privacyPolicy" className="font-semibold" target="_blank">
        privacy policy
      </Link>
    </span>
  );
};

export default TermsAndConditionLabel;
